export default __webpack_public_path__ + "static/loader-bcd8ea90268ad08408a0a2be92c760ec.gif";